var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgListAlt = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.84375 1.59375H1.875C1.15625 1.59375 0.53125 2.1875 0.53125 2.9375V4.90625C0.53125 5.625 1.125 6.25 1.875 6.25H3.84375C4.5625 6.25 5.1875 5.65625 5.1875 4.90625V2.90625C5.15625 2.1875 4.5625 1.59375 3.84375 1.59375ZM3.75 4.8125H1.96875V3H3.75V4.8125Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03125 4.625H18.75C19.125 4.625 19.4688 4.3125 19.4688 3.90625C19.4688 3.5 19.1562 3.1875 18.75 3.1875H8.03125C7.65625 3.1875 7.3125 3.5 7.3125 3.90625C7.3125 4.3125 7.65625 4.625 8.03125 4.625Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84375 8H1.875C1.15625 8 0.53125 8.59375 0.53125 9.34375V11.3125C0.53125 12.0312 1.125 12.6562 1.875 12.6562H3.84375C4.5625 12.6562 5.1875 12.0625 5.1875 11.3125V9.34375C5.15625 8.59375 4.5625 8 3.84375 8ZM3.75 11.2187H1.96875V9.40625H3.75V11.2187Z",
    fill: "#6B7280"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 9.625H8.03125C7.65625 9.625 7.3125 9.9375 7.3125 10.3437C7.3125 10.75 7.625 11.0312 8.03125 11.0312H18.75C19.125 11.0312 19.4688 10.7187 19.4688 10.3437C19.4688 9.96875 19.125 9.625 18.75 9.625Z",
    fill: "#6B7280"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84375 14.7812H1.875C1.15625 14.7812 0.53125 15.375 0.53125 16.125V18.0937C0.53125 18.8125 1.125 19.4375 1.875 19.4375H3.84375C4.5625 19.4375 5.1875 18.8437 5.1875 18.0937V16.125C5.15625 15.375 4.5625 14.7812 3.84375 14.7812ZM3.75 18H1.96875V16.1875H3.75V18Z",
    fill: "#6B7280"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 16.375H8.03125C7.65625 16.375 7.3125 16.6875 7.3125 17.0937C7.3125 17.5 7.625 17.8125 8.03125 17.8125H18.75C19.125 17.8125 19.4688 17.5 19.4688 17.0937C19.4688 16.6875 19.125 16.375 18.75 16.375Z",
    fill: "#6B7280"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgListAlt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/list-alt.a4445166f9241d1bb4253ed5ef7f89a1.svg";